module.exports = __webpack_public_path__ + "static/media/0028.c0fb09c9.png";